import React, { useState } from "react";
import { Box } from "@mui/material";
import GloboRouteWrapper from "../../components/Globo/Wrappers/GloboRouteWrapper";
import NavigationTabs from "../../components/Globo/Tabs/NavigationTabs";
import UserManagement from "./UserManagement/UserManagement";

const TABS = [{ value: "users", label: "Gestão de Usuários" }];

const Maintenance = () => {
  const [tab, setTab] = useState(TABS[0].value);

  return (
    <GloboRouteWrapper
      maxWidth="1232px"
      headerProps={{ title: "Script - Manutenção" }}
    >
      <Box
        sx={{
          height: "calc(100vh - 64px)",
          display: "flex",
          flexDirection: "column",
          px: 4,
          pt: 2,
          pb: 2,
        }}
      >
        <NavigationTabs tabs={TABS} value={tab} onChange={setTab} sx={{ flexShrink: 0 }} />

        <Box sx={{ flex: 1, minHeight: 0, mt: 2 }}>
          {tab === "users" && <UserManagement />}
        </Box>
      </Box>
    </GloboRouteWrapper>
  );
};

export default Maintenance;
